import { ThemeOptions } from '@mui/material/styles';
import { baseComponents, baseShape, baseSpacing, baseTypography } from './baseTheme';

/**
 * Modern Dark Theme
 * Primary: Purple (#bb86fc)
 * Secondary: Teal (#03dac6)
 * Target: Modern UI preference
 * Optimized for compact, data-dense displays
 */
export const darkTheme: ThemeOptions = {
    palette: {
        mode: 'dark',
        primary: {
            main: '#bb86fc',
            light: '#d0a9ff',
            dark: '#9c64e0',
            contrastText: '#000',
        },
        secondary: {
            main: '#03dac6',
            light: '#66fff9',
            dark: '#00a896',
            contrastText: '#000',
        },
        background: {
            default: '#121212',
            paper: '#1e1e1e',
        },
        text: {
            primary: '#ffffff',
            secondary: '#b0b0b0',
        },
        error: {
            main: '#cf6679',
        },
        warning: {
            main: '#ffb74d',
        },
        info: {
            main: '#4fc3f7',
        },
        success: {
            main: '#81c784',
        },
    },
    typography: baseTypography,
    spacing: baseSpacing,
    shape: baseShape,
    components: {
        ...baseComponents,
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
                },
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: '#1a1a1a',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#1e1e1e',
                },
            },
        },
    },
};
